import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronBoldDown = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M18.755 29.195 4.515 14.953a1.759 1.759 0 0 1 0-2.487l1.66-1.661a1.759 1.759 0 0 1 2.485-.003l11.339 11.287 11.34-11.286a1.758 1.758 0 0 1 2.484.003l1.661 1.66c.687.688.687 1.801 0 2.488L21.242 29.195a1.76 1.76 0 0 1-2.487 0Z" })
});
export default SvgChevronBoldDown;
